import {
  whiteColor,
  oceanBlueColor,
  DodgerBlueColor,
  grayColor,
  blueColor,
} from "../../cmsMainStyle";

const transmittalInboxListStyle = (theme) => ({
  root: {
    "& .MuiTextField-root": {
      marginTop: theme.spacing(2),
    },
    "& .MuiDataGrid-columnHeaderWrapper": {
      fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
      fontSize: "14px",
      color: grayColor[10],
      backgroundColor: blueColor[0],
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
  transmittalList: {
    height:
      window.outerHeight - (window.outerHeight - window.innerHeight + 250),
    // overflowY: "auto",
    // overflowX: "hidden",
  },
  readedIcon: {
    color: oceanBlueColor[7],
  },

  unreadIcon: {
    color: oceanBlueColor[12],
  },
  viewIcon: {
    cursor: "pointer",
    color: oceanBlueColor[12],
  },
});

export { transmittalInboxListStyle };
